export default "__VITE_ASSET__$D3iTcO2__"